import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { APPLE_PAY_MERCHANT_ID } from '../../../../../const';
import PaymentApi from '../../../../../service/Api/paymentApi';
import CheckoutRisk from '../../../../../service/CheckoutRisk';
import LoggerService from '../../../../../service/LoggerService';
import { createNativeMethodToken } from '../../../../../store/slices/paymentsSlice';
import { gaEvents } from '../../../../../utils/analytics';
import { NATIVE_METHOD_PAYMENT_TYPE } from '../index';
import styles from './styles.module.scss';

const ApplePaymentButton = ({ price, paymentDispatch, countryCode, paymentTexts, setHidden }) => {
    const dispatch = useDispatch();

    const onPay = async (token, callback) => {
        console.log('onPay');
        gaEvents.onApplePay();
        const deviceSessionId = await CheckoutRisk.getDeviceSessionId();
        await dispatch(createNativeMethodToken({ type: NATIVE_METHOD_PAYMENT_TYPE.APPLE, token: token.paymentData })).then((res) => {
            if (res.meta.requestStatus === 'fulfilled' && res?.payload?.success) {
                paymentDispatch(res.payload.data, deviceSessionId);
            }
            callback(res?.payload?.data);
        });
    };

    const validationSession = async (url, cb) => {
        PaymentApi.validationAppleSession({ appleUrl: url })
            .then((result) => {
                cb(result.data);
            })
            .catch(() => {});
    };

    const subscribe = async () => {
        console.log('addEventListener click start');

        const appleSession = new ApplePaySession(6, {
            countryCode,
            currencyCode: price?.currency?.code,
            merchantCapabilities: ['supports3DS'],
            supportedNetworks: ['visa', 'masterCard'],
            total: {
                label: paymentTexts?.info || 'Veda purchases',
                type: 'final',
                amount: `${price?.value}`
            }
        });

        appleSession.begin();
        appleSession.onvalidatemerchant = (event) => {
            validationSession(event.validationURL, (merchantSession) => {
                appleSession.completeMerchantValidation(merchantSession.data);
            });
        };

        appleSession.onpaymentauthorized = (event) => {
            const paymentToken = event.payment.token;

            onPay(paymentToken, (outcome) => {
                if (outcome) {
                    appleSession.completePayment(ApplePaySession.STATUS_SUCCESS);
                } else {
                    appleSession.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            });
        };
    };

    useEffect(() => {
        const appleButton = document.querySelector('.apple-pay-button');

        if (!window.ApplePaySession && !window.ApplePaySession?.canMakePayments()) {
            console.log('Apple payment not supported');
            return;
        }
        ApplePaySession.canMakePaymentsWithActiveCard(APPLE_PAY_MERCHANT_ID).then((result) => {
            if (!result) {
                LoggerService.log('canMakePaymentsWithActiveCard not supported');
                return;
            }
            setHidden(false);
            appleButton.style.display = 'block';
        });

        appleButton.style.opacity = '1';
        appleButton.style.width = '100%';

        appleButton.addEventListener('click', subscribe);

        return () => {
            appleButton.removeEventListener('click', subscribe);
        };
    }, [setHidden, subscribe]);
    console.log('render apple pay button');

    return (
        <div className={classNames(styles.widht)}>
            <div className="apple-pay-button"></div>
        </div>
    );
};

export default ApplePaymentButton;
